/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-03-24 14:03:37
 */
import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 自定义页面数据
 */
const frontEndPageCustomParam = {
  /**
   * 获取页面自定义数据
   */
  getFrontEndPageCustomParam(roleId, pagePath, param) {
    let pageInstanceName = "";
    return axios.post(
      base.frontEndPageCustomParam.getFrontEndPageCustomParam,
      utils.postParamsArrayToJsonString({
        roleId,
        pagePath,
        param,
        pageInstanceName,
      })
    );
  },
  /**
   * 设置页面自定义数据
   */
  setFrontEndPageCustomParam(
    roleId,
    pagePath,
    param,
    value,
    pageInstanceName = ""
  ) {
    return axios.post(
      base.frontEndPageCustomParam.setFrontEndPageCustomParam,
      utils.postParamsArrayToJsonString({
        roleId,
        pagePath,
        param,
        value,
        pageInstanceName,
      })
    );
  },
  /**
   * 删除页面自定义数据
   */
  deleteFrontEndPageCustomParam(
    roleId,
    pagePath,
    param,
    pageInstanceName = ""
  ) {
    return axios.post(
      base.frontEndPageCustomParam.deleteFrontEndPageCustomParam,
      utils.postParamsArrayToJsonString({
        roleId,
        pagePath,
        param,
        pageInstanceName,
      })
    );
  },
  /**
   * 获取自身自定义页面数据
   */
  getMyFrontEndPageCustomParam(companyId, pagePath, param) {
    return axios.post(
      base.frontEndPageCustomParam.getMyFrontEndPageCustomParam,
      utils.postParamsArrayToJsonString({ companyId, pagePath, param })
    );
  },
};

export default frontEndPageCustomParam;
